import React from 'react';
import { SvgIcon, useMediaQuery } from '@mui/material';
import { ReactComponent as DrSmileImpressLogo } from 'mui/assets/icons/DRSXIMPRESS.svg';
import { ReactComponent as DrSmileImpressLogoDesktop } from 'mui/assets/icons/DRSXIMPRESS-desktop.svg';
import { ReactComponent as DrSmileLogoIcon } from 'mui/assets/icons/drsmile-black-logo.svg';
import { isDRSmileInactive } from '../../../../data/isDRSmileInactive';
import { getDSFooterCFQueryData } from './DS_FooterFragment';
import DS_FooterContactMenu from './elements/DS_FooterContactMenu';
import DS_FooterBasicMenu from './elements/DS_FooterBasicMenu';
import DS_FooterSocialMenu from './elements/DS_FooterSocialMenu';
import DS_FooterReview from './elements/DS_FooterReview';
import DS_FooterLocations from './elements/DS_FooterLocations';
import DS_FooterCopyrightMenu from './elements/DS_FooterCopyrightMenu';
import {
  StyledFooter,
  StyledFooterDivider,
  StyledFooterHeader,
  StyledFooterInner,
  StyledFooterLogo,
  StyledFooterMenuList,
  StyledFooterSocialMenuList,
} from './DS_FooterStyles';

const DS_Footer = ({ simpleFooter }) => {
  const { data } = getDSFooterCFQueryData();
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('lg'));

  const logoComponent = isDesktop ? DrSmileImpressLogoDesktop : DrSmileImpressLogo;
  const brandLogo = isDRSmileInactive ? DrSmileLogoIcon : logoComponent;
  return (
    <StyledFooter>
      <StyledFooterInner>
        {!simpleFooter ? (
          <>
            <StyledFooterHeader $isDRSmileInactive={isDRSmileInactive}>
              <StyledFooterLogo>
                <SvgIcon data-qa="drsmile-logo-footer" component={brandLogo} inheritViewBox={true}></SvgIcon>
              </StyledFooterLogo>
              {data?.contactMenuItems && <DS_FooterContactMenu items={data.contactMenuItems} />}
            </StyledFooterHeader>

            <StyledFooterDivider />
            <StyledFooterMenuList>
              {data?.aboutUsMenuItems && (
                <DS_FooterBasicMenu label={data.aboutUsMenuLabel} items={data.aboutUsMenuItems} />
              )}
              {data?.productMenuItems && (
                <DS_FooterBasicMenu label={data.productMenuLabel} items={data.productMenuItems} />
              )}
              {data?.treatmentMenuItems && (
                <DS_FooterBasicMenu label={data.treatmentMenuLabel} items={data.treatmentMenuItems} />
              )}
              <StyledFooterSocialMenuList>
                {data?.socialMenuItems && (
                  <DS_FooterSocialMenu
                    label={data.socialMenuLabel}
                    items={data.socialMenuItems}
                    influencerLink={data.influencerLink}
                  />
                )}
                {data?.feedbackLogo && data?.feedbackStars && data?.feedbackInfo && (
                  <DS_FooterReview logo={data.feedbackLogo} stars={data.feedbackStars} info={data.feedbackInfo} />
                )}
              </StyledFooterSocialMenuList>
            </StyledFooterMenuList>
            <StyledFooterDivider />
            {data?.locations && (
              <>
                <DS_FooterLocations
                  label={data.locationsHeader}
                  items={data.locations}
                  moreLink={data.locationsMoreLink}
                />
                <StyledFooterDivider />
              </>
            )}
          </>
        ) : null}

        {data?.copyrightsMenuItems && (
          <DS_FooterCopyrightMenu label={data.copyrightsMenuLabel} items={data.copyrightsMenuItems} />
        )}
      </StyledFooterInner>
    </StyledFooter>
  );
};

export default DS_Footer;
